export default __webpack_public_path__ + "static/media/volume-mute.dd59cc63.svg";